import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a14264c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "interact-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"24px"} }, "Select a User", -1))
const _hoisted_4 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_5 = { class: "values-group _bordered" }
const _hoisted_6 = { class: "row mt-1" }
const _hoisted_7 = { class: "col-8" }
const _hoisted_8 = { class: "row mt-1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Production Branch:", -1))
const _hoisted_10 = { class: "col-8 text-start" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "row mt-1" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Delivery Branch:", -1))
const _hoisted_15 = { class: "col-8 text-start" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "col-4 reset-container" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Reset")
const _hoisted_20 = { class: "values-group" }
const _hoisted_21 = { class: "row mt-1" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Suppress Email Tracking Notifications:", -1))
const _hoisted_23 = { class: "col-8 text-start" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_26 = { ref: "grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_kendo_ddl = _resolveComponent("kendo-ddl")!
  const _component_KButton = _resolveComponent("KButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _hoisted_3,
            _createVNode(_component_kendo_ddl, {
              ref: "userDdl",
              modelValue: _ctx.currentUser,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentUser) = $event)),
              class: "ddl users-ddl",
              "data-items": _ctx.users,
              "text-field": 'Combined',
              "data-item-key": 'Id',
              filterable: true,
              "value-primitive": false,
              "item-render": _ctx.usersListOptionTemplate,
              onFilterchange: _ctx.filterChange,
              onChange: _ctx.selectUser
            }, null, 8, ["modelValue", "data-items", "item-render", "onFilterchange", "onChange"]),
            (_ctx.isBusy)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productionBranchId) = $event)),
                      disabled: _ctx.isBusy,
                      class: "form-select"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.branches, (branch) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: branch.Id,
                          value: branch.Id
                        }, _toDisplayString(branch.Name), 9, _hoisted_12))
                      }), 128))
                    ], 8, _hoisted_11), [
                      [_vModelSelect, _ctx.productionBranchId]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.deliveryBranchId) = $event)),
                      disabled: _ctx.isBusy,
                      class: "form-select"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.branches, (branch) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: branch.Id,
                          value: branch.Id
                        }, _toDisplayString(branch.Name), 9, _hoisted_17))
                      }), 128))
                    ], 8, _hoisted_16), [
                      [_vModelSelect, _ctx.deliveryBranchId]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                (_ctx.isResetAvailable)
                  ? (_openBlock(), _createBlock(_component_KButton, {
                      key: 0,
                      disabled: _ctx.isBusy,
                      onClick: _ctx.onReset
                    }, {
                      default: _withCtx(() => [
                        _hoisted_19
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.suppressTrackingNotifications) = $event)),
                  disabled: _ctx.isBusy,
                  type: "checkbox"
                }, null, 8, _hoisted_24), [
                  [_vModelCheckbox, _ctx.suppressTrackingNotifications]
                ])
              ])
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSaveClick && _ctx.onSaveClick(...args)))
          }, "Save")
        ])
      ])
    ]),
    _hoisted_25,
    _createElementVNode("div", _hoisted_26, null, 512)
  ], 64))
}